import {
  AutoCompleteDepartment,
  SelectInstitution,
  SelectMappedProfile,
} from "SuperAdmin/Components";
import { ConstantVariables } from "SuperAdmin/Config/ConstantVariables";
import { formItemLayout } from "SuperAdmin/Config/FormLayout";
import { IconPack } from "SuperAdmin/Config/Icon";
import { Button, Form, Input, Modal, Radio } from "antd";
import { getSearchAuthors } from "Explore/Services/Author";
import { getSearchInstitutions } from "Explore/Services/Institution";
import { useState } from "react";
import CreateRoleForm from "../CreateRoleForm/CreateRoleForm";
import Roles from "../Roles/Roles";
import styles from "./Form.module.scss";

const FormUpdate = ({
  form,
  mappedProfileID,
  role,
  addedRole,
  setAddedRole,
  onFinishForm,
}) => {
  const [openCreateRole, setOpenCreateRole] = useState(false);
  const handleDeleteMappedProfile = () => {
    form.setFieldsValue({
      mapped_profile_id: null,
      name: "",
      email: "",
      institution: "",
      department: "",
      position: "",
      profile_url: "",
      activate: 1,
      role: [
        {
          type: 3,
          name: "",
          institution: "",
          position: "",
        },
      ],
    });
  };

  return (
    <div className={styles["update-form"]}>
      <Modal
        title="Basic Modal"
        open={openCreateRole}
        // onOk={handleCreateRole}
        onCancel={() => setOpenCreateRole(false)}
      >
        <CreateRoleForm
          form={form}
          role={role}
          setOpenCreateRole={setOpenCreateRole}
          setAddedRole={setAddedRole}
        />
      </Modal>
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        onFinish={onFinishForm}
      >
        <Form.Item
          label={"Mapped profile:"}
          labelAlign="left"
          name="mapped_profile_id"
        >
          <SelectMappedProfile
            placeholder="Search for a faculty profile"
            functionSearch={getSearchAuthors}
            form={form}
          />
          {mappedProfileID && (
            <div className={styles["mapped-profile"]}>
              <div className={styles["profile-summary"]}>
                <div className={styles["profile-img"]}>
                  <img
                    src={
                      form.getFieldValue("photo_url")
                        ? form.getFieldValue("photo_url")
                        : ConstantVariables.no_photo_faculty
                    }
                    alt="mapped-profile-photo"
                  />
                </div>
                <div className={styles["profile-info"]}>
                  <p className={styles["profile-name"]}>
                    {form.getFieldValue("name")}
                  </p>
                  <p>{form.getFieldValue("department")}</p>
                  <p>{form.getFieldValue("position")}</p>
                </div>
              </div>
              <div
                className={styles["delete-mapped-profile"]}
                onClick={handleDeleteMappedProfile}
              >
                {IconPack.close_icon}
              </div>
            </div>
          )}
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Name:"}
          labelAlign="left"
          name="name"
        >
          <Input
            placeholder="Please input the name"
            disabled={form.getFieldValue("name") ? true : false}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Email:"}
          labelAlign="left"
          name="email"
        >
          <Input placeholder="Please input the email" />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Institution:"}
          labelAlign="left"
          name="institution_id"
        >
          <SelectInstitution
            placeholder={"Search for institution"}
            functionSearch={getSearchInstitutions}
            form={form}
            disabled={form.getFieldValue("institution_id") ? true : false}
            mappedProfile={
              form.getFieldValue("mapped_profile_id")
                ? {
                    id: form.getFieldValue("institution_id"),
                    name: form.getFieldValue("institution_name"),
                  }
                : null
            }
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Department:"}
          labelAlign="left"
          name="department"
        >
          <AutoCompleteDepartment
            placeholder="Please input the department"
            institutionName={form.getFieldValue("institution_name")}
            form={form}
            tagColor="blue"
            disabled={
              form.getFieldValue("mapped_profile_id")
                ? true
                : form.getFieldValue("institution_id")
                ? false
                : true
            }
          />
        </Form.Item>
        <Form.Item label={"Position:"} labelAlign="left" name="position">
          <Input
            placeholder="Please input the position"
            disabled={form.getFieldValue("position") ? true : false}
          />
        </Form.Item>
        <Form.Item
          label={"Personal page:"}
          labelAlign="left"
          name="profile_url"
        >
          <Input
            placeholder="Please input the homepage"
            disabled={form.getFieldValue("profile_url") ? true : false}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Account status:"}
          labelAlign="left"
          name="activate"
        >
          <Radio.Group>
            <Radio value={1}>Enable</Radio>
            <Radio value={2}>Disable</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Roles:"}
          labelAlign="left"
          name="role"
        >
          <Roles
            addedRole={addedRole}
            setAddedRole={setAddedRole}
            form={form}
            setOpenCreateRole={setOpenCreateRole}
          />
        </Form.Item>
        <div className={styles["update-button"]}>
          <Button htmlType="submit" type="primary">
            Create
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormUpdate;
